import { AppModules } from 'appContainer/types';
import {
  IndexRouteContent,
  LayoutRouteContent,
  PathRouteContent,
  RouteNode,
} from 'router/declarative/routeNode';
import { Features } from '@ardoq/features';
import { featureFlagBoundary } from 'router/declarative/featureFlagBoundary';

export const routes = {
  path: '/transformations',
  title: 'Transform',
  appModule: AppModules.TRANSFORMATIONS,
  content: featureFlagBoundary([Features.TRANSFORMATIONS], {
    pageName: 'Transformations',
  }),
  children: [
    {
      path: { layout: true },
      content: async (): LayoutRouteContent =>
        (await import('./TransformationsLayout')).TransformationsLayout,
      children: [
        {
          path: { index: true },
          content: async (): IndexRouteContent =>
            (await import('./InitiativesOverview')).InitiativesOverview,
        },
        {
          path: '/initiatives',
          children: [
            {
              path: '/:initiativeId',
              children: [
                {
                  path: { index: true },
                  content: async (): IndexRouteContent =>
                    (await import('./initiativePage/InitiativePageV2'))
                      .InitiativePageV2,
                },
                {
                  path: '/future-states',
                  children: [
                    {
                      path: '/:futureStateId',
                      content: async (): PathRouteContent =>
                        (await import('./futureStatePage/FutureStatePage'))
                          .FutureStatePage,
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
} as const satisfies RouteNode;
